import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ISession } from '@core/models-v2/auth/session.interface';
import { IEcommerceUser } from '@core/models-v2/auth/user.interface';
import { SubAccountService } from '@core/services-v2/sub-account.service';
import { DataTableDirective } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../../service/users.service';

@Component({
  selector: 'app-tabla-usuario',
  templateUrl: './tabla-usuario.component.html',
  styleUrls: ['./tabla-usuario.component.scss'],
})
export class TablaUsuarioComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  datatableElement!: DataTableDirective;
  @Input() userSession!: ISession;
  session!: ISession;
  dtOptions: DataTables.Settings = {};
  loadingData = false;
  users: IEcommerceUser[] = [];
  editUser = false;
  selectedUsers: any[] = [];
  isMobile = false;
  constructor(
    private toastr: ToastrService,
    private userService: UsersService,
    // Services V2
    private readonly subAccountService: SubAccountService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.checkIsMobile();
    window.addEventListener('resize', () => {
      this.checkIsMobile();
    });
    this.loadDataToPrimeNGTable();
    this.userService.loadDataRead$.subscribe((resp) => {
      this.loadDataToPrimeNGTable();
    });
  }
  checkIsMobile() {
    // this.isMobile = window.innerWidth < 768;
    this.isMobile = window.innerWidth <= 800;
    this.cdr.detectChanges();
  }

  crearUsuario() {
    let json = {
      data: {},
      delete: false,
      edit: false,
      raiz: this.session,
    };

    this.userService.activarModal(json);
  }

  onlyName(username: string | undefined | null): string {
    if (!username) {
      return '';
    }
    return username.split('@')[0];
  }

  Editar(item: any) {
    let json = {
      data: item,
      delete: false,
      edit: true,
      raiz: this.userSession,
    };

    this.userService.activarModal(json);
  }
  //esto es para la tabla en primeNG
  loadDataToPrimeNGTable() {
    let user = {
      rut: this.userSession.documentId,
      username: this.userSession.username,
    };
    this.loadingData = true;
    this.subAccountService.getSubAccounts({ documentId: user.rut }).subscribe({
      next: (resp: { data: IEcommerceUser[]; total: number }) => {
        this.users = resp.data;
        this.loadingData = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log('Error al cargar los usuarios:', err);
        this.toastr.error('Error de conexión al obtener usuarios');
        this.loadingData = false;
      },
    });
  }

  Eliminar(item: any) {
    let json = {
      data: item,
      delete: true,
      edit: false,
      raiz: this.userSession,
    };
    this.userService.activarModal(json);
  }
}
